import { ReactElement } from 'react';
import { Stack, Typography, Grid } from '@mui/material';
import { amber } from '@mui/material/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown as CrownIcon } from '@fortawesome/free-solid-svg-icons';

import AccessFeature from '~components/AccessFeature';

import { CustomPlanInfoCardProps } from './types';
import {
  CustomPlanInfoCardRoot,
  CustomPlanInfoCardCheckIcon,
  CustomPlanCardRecommendedChip,
} from './styles';

const SubscriptionCustomPlanInfoCard = ({
  name,
  features,
  isRecommended = false,
}: CustomPlanInfoCardProps): ReactElement => (
  <CustomPlanInfoCardRoot isRecommended={isRecommended}>
    <Stack spacing={1} flex={1}>
      <Stack
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack spacing={1} direction="row" alignItems="baseline">
          <Typography variant="h4" fontWeight="bold" fontSize={26}>
            {name}
          </Typography>

          <FontAwesomeIcon icon={CrownIcon} color={amber[500]} fontSize={20} />
        </Stack>

        <AccessFeature.UpgradePlanButton.ContactSales
          variant="outlined"
          color="primary"
          size={isRecommended ? 'small' : 'medium'}
        />
      </Stack>

      <Typography variant="caption" fontWeight="bold">
        Un plan diseñado para satisfacer todos los requerimientos de tu empresa
      </Typography>

      <Stack maxWidth={500}>
        <Grid container spacing={0}>
          {features.map((feature, index) => (
            <Grid
              key={`custom-plan-info-card-${name}-feature-${index}`}
              item
              xs={6}
              alignItems="flex-start"
            >
              <CustomPlanInfoCardCheckIcon />

              <Typography variant="caption">{feature}</Typography>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Stack>

    {isRecommended && (
      <CustomPlanCardRecommendedChip label="RECOMENDADO" variant="filled" />
    )}
  </CustomPlanInfoCardRoot>
);

export default SubscriptionCustomPlanInfoCard;
